module.exports = __webpack_public_path__ + "media/icons/loading-1c36d462.svg";